module.exports = __webpack_public_path__ + "static/906-4ef9a142d3f49cf3e9f0bb3c721181e3.png";